/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/DefaultEntityStateWorkflow
 * @desc Set the default_entity_state_workflow for this group
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { EntityStateWorkflow } from 'labstep-web/models/entity-state-workflow.model';
import type React from 'react';
import type { GroupFormShowEditDefaultEntityStateWorkflowProps } from './types';

export const GroupFormShowEditDefaultEntityStateWorkflow: React.FC<
  GroupFormShowEditDefaultEntityStateWorkflowProps
> = ({ group }) => (
  <FormShowEditSearchSelect
    childEntityName={EntityStateWorkflow.entityName}
    parentEntity={group}
    searchSelectProps={{
      params: { group_id: group.id },
      creatable: true,
      createBody: { group_id: group.id },
    }}
    childKeyName="default_entity_state_workflow"
  >
    {group.default_entity_state_workflow && (
      <div>
        <EntityLink entity={group.default_entity_state_workflow} />
      </div>
    )}
  </FormShowEditSearchSelect>
);
